import React, { useEffect, useState } from "react";
import generalLedgerAPI from "../../api/generalLedgerAPI";
import { useAuth } from "../../context/AuthContext";

const JournalEntryGLTab = ({ journalEntryId, status }) => {
  const { isAuthReady, selectedClient } = useAuth();
  const tenantType = localStorage.getItem('tenantType');
  const billingAccountingClientId = selectedClient?._id || localStorage.getItem('accountingClientId') || null;
  const [loading, setLoading] = useState(false);
  const [glEntries, setGlEntries] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!journalEntryId || status === "draft" || !isAuthReady) return;

    const fetchGL = async () => {
      try {
        setLoading(true);
        setError("");

        const params = { journalEntry: journalEntryId };

        // Billing tenant: scope GL query to the active accounting client
        if (tenantType === 'billing' && billingAccountingClientId) {
          params.accountingClientId = billingAccountingClientId;
        }

        const data = await generalLedgerAPI.getAll(params);

        setGlEntries(data?.data || data || []);
      } catch (err) {
        setError(typeof err === "string" ? err : "Failed to load GL postings");
      } finally {
        setLoading(false);
      }
    };

    fetchGL();
  }, [journalEntryId, status, isAuthReady]);

  if (status === "draft") {
    return (
      <div className="text-gray-500">
        This journal entry has not yet been posted to the General Ledger.
      </div>
    );
  }

  if (loading) {
    return <div className="text-gray-500">Loading GL postings...</div>;
  }

  if (error) {
    return <div className="text-red-600">{error}</div>;
  }

  if (!glEntries.length) {
    return <div className="text-gray-500">No GL postings found.</div>;
  }

  return (
    <div>
      <h2 className="text-lg font-semibold mb-4">General Ledger Impact</h2>

      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200 text-sm">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase">
                Account
              </th>
              <th className="px-4 py-3 text-right font-medium text-gray-500 uppercase">
                Debit
              </th>
              <th className="px-4 py-3 text-right font-medium text-gray-500 uppercase">
                Credit
              </th>
              <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase">
                Transaction Date
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-200 bg-white">
            {glEntries.map((entry) => (
              <tr key={entry._id}>
                <td className="px-4 py-2">
                  {entry.account?.accountNumber
                    ? `${entry.account.accountNumber} - ${entry.account.accountName}`
                    : entry.account}
                </td>
                <td className="px-4 py-2 text-right">
                  {entry.debit > 0 ? entry.debit.toFixed(2) : "-"}
                </td>
                <td className="px-4 py-2 text-right">
                  {entry.credit > 0 ? entry.credit.toFixed(2) : "-"}
                </td>
                <td className="px-4 py-2">
                  {entry.transactionDate?.split("T")[0]}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default JournalEntryGLTab;